/**
 * Which plan vaccines a SOAP note still has to settle (spec §2): `pending` is every one not yet recorded from
 * this note or confirmed as a dose already on the chart; `toAsk` are those with a dose on the chart that day
 * and no answer yet ("is it that dose?"); `toRecord` are the rest, offered as new vaccination records. "It is
 * that dose" settles a vaccine only while that dose is still on the chart for the note's day.
 */
export function splitPlanVaccines(
  names: string[],
  recorded: Set<string>,
  decisions: Record<string, 'same' | 'new'>,
  onChartThatDay: (name: string) => boolean,
): { pending: string[]; toAsk: string[]; toRecord: string[] } {
  const pending = names.filter((n) => !recorded.has(n) && !(decisions[n] === 'same' && onChartThatDay(n)));
  const toAsk = pending.filter((n) => decisions[n] !== 'new' && onChartThatDay(n));
  return { pending, toAsk, toRecord: pending.filter((n) => !toAsk.includes(n)) };
}
